module.exports = __webpack_public_path__ + "static/img/window.2644858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/window.png
// module id = K1Pa
// module chunks = 101